<script>
</script>

<footer>
  <div class="credits">
    <p>Concept by: <a href="https://www.glotavarez.com/">Glo Tavarez</a></p>
    <p>
      Made by the worst guy: <a href="https://www.evanfordebarden.com"
        >Evan Forde Barden</a
      >
    </p>
  </div>
</footer>

<style>
  footer {
    padding-bottom: 40px;
    text-align: center;
    position: absolute;
    bottom: 0;
    display: flex;
    width: 100%;
    justify-content: center;
  }
  .credits {
    color: rgb(70, 79, 103);
    font-size: 0.6em;
    display: inline-block;
    padding: 1.2em;
    border-top: 1px solid #ddd;
  }
</style>
